<div class="step-container" *transloco="let t">
	<!-- Only show the progress bar when doing a local network scan. Makes no sense otherwise. -->
	@if (claimingMethod === 'ClaimByTokenOnLocalNetwork' || loadingData) {
		<prism-progress-indicator
			slot="dialog-progress-indicator"
			mode="indeterminate"
			id="sh-claimng-result-progress-bar"
		/>
	}

	<p id="add-devices-step2-mac-serial-title" *ngIf="claimingMethod === 'ClaimByMacSerialSingle'">
		{{ t('cloud.add-devices-dialog.confirm-device-details') }}.
	</p>
	<p id="add-devices-step2-mac-serial-title" *ngIf="claimingMethod === 'ClaimByMacSerialCsv'">
		<ng-container *ngIf="stepConfig.extractedDevices().length === 1; else csvFileReadMsgPlural">
			{{ t('cloud.add-devices-dialog.csv-file-read-msg-singular') }}
		</ng-container>
		<ng-template #csvFileReadMsgPlural>
			{{ t('cloud.add-devices-dialog.csv-file-read-msg-plural', { x: stepConfig.extractedDevices().length }) }}
		</ng-template>
		{{ t('cloud.add-devices-dialog.select-devices') }}.
	</p>
	<p id="add-devices-step2-local-scan-title" *ngIf="claimingMethod === 'ClaimByTokenOnLocalNetwork'">
		{{ t('cloud.add-devices-dialog.scanning-for-devices-local-network') }}
	</p>

	@if (claimingMethod === 'ClaimByTokenOnLocalNetwork') {
		<div class="local-network-table-container">
			<sh-local-network-table
				id="sh-devices-local-network-table"
				class="sh-local-network-table"
				[devices]="discoveredDevices$ | async"
				(selectionChange)="onSelectionChange($event)"
			>
			</sh-local-network-table>
		</div>
	} @else if (claimingMethod === 'ClaimByMacSerialSingle' || claimingMethod === 'ClaimByMacSerialCsv') {
		<sh-mac-serial-table
			id="sh-devices-mac-serial-table"
			class="sh-mac-serial-table"
			[devices]="stepConfig.extractedDevices()"
			(selectionChange)="onSelectionChange($event)"
		>
		</sh-mac-serial-table>
	} @else if (claimingMethod === 'ClaimByQrCode') {
		@if (stepConfig.activeQrCodeClaimStep() === qrCodeClaimStepEnum.Scan) {
			<sh-qr-code-scan-step></sh-qr-code-scan-step>
		} @else {
			<sh-mac-serial-table
				id="sh-devices-mac-serial-table"
				class="sh-mac-serial-table"
				[devices]="stepConfig.extractedDevices()"
				(selectionChange)="onSelectionChange($event)"
			>
			</sh-mac-serial-table>
		}
	}
</div>
